import { Button } from "../../../../../core/Button.js";
import { Text } from "../../../../../core/Text.js";
import { BattleSeatCard } from "../../../../../domain/battles/BattleSeatCard.js";
import { cn } from "../../../../../foundations/cn.js";
import { ActionButton } from "../../../../shared/ActionButton.js";
import type { BattleRoomSeatsContent } from "../../../battlesContent.js";

/** Up to three across, so a six-seat battle takes two rows and a two-seat one sits wide. */
const COLUMNS: Record<number, string> = {
  1: "md:grid-cols-1",
  2: "md:grid-cols-2",
  3: "md:grid-cols-3",
};

/**
 * Before the battle starts: every seat as a card, an empty one with the ways to fill it; then how
 * many more it waits for, and starting early with bots where the viewer may.
 */
export function BattleRoomSeats({ seats, pending, footer }: BattleRoomSeatsContent) {
  return (
    <section className="flex flex-col gap-4">
      <ul
        className={cn(
          "grid grid-cols-2 gap-3 md:gap-4",
          COLUMNS[Math.min(3, seats.length)] ?? "md:grid-cols-3",
        )}
      >
        {seats.map((card) => (
          <li key={card.seatLabel} className="flex min-w-0">
            <BattleSeatCard
              seatLabel={card.seatLabel}
              seat={card.seat}
              className="flex-1"
              actions={
                card.actions.length > 0
                  ? card.actions.map((action) =>
                      action.href !== undefined ? (
                        <ActionButton
                          key={action.label}
                          action={action}
                          variant={action.emphasis}
                          size="sm"
                        />
                      ) : (
                        <Button
                          key={action.label}
                          variant={action.emphasis}
                          size="sm"
                          disabled={pending}
                          onClick={action.onClick}
                        >
                          {action.label}
                        </Button>
                      ),
                    )
                  : undefined
              }
            />
          </li>
        ))}
      </ul>
      {footer && (
        <div className="flex flex-wrap items-center justify-between gap-3">
          <Text variant="body-b2" tone="secondary" role="status">
            {footer.message}
          </Text>
          {footer.start && (
            <Button
              variant={footer.start.emphasis}
              size="sm"
              disabled={pending}
              onClick={footer.start.onStart}
            >
              {footer.start.label}
            </Button>
          )}
        </div>
      )}
    </section>
  );
}
